import 'jquery'

$('.navbar-toggle').click(() => {
  $(this).toggleClass('is-active')
})

function moveScroller() {
  const topElem = $('.banner-image')
  const menu = $('.nav-container-absolute')
  const topElemHeight = topElem.outerHeight()
  const topElemOffset = topElem.offset().top
  const menuOffset = 32
  const breakpoint = topElemOffset + topElemHeight - menuOffset

  $(window).scroll(() => {
    const currentPos = $(window).scrollTop()
    if (currentPos < breakpoint) {
      menu.removeClass('nav-container-fixed')
      menu.addClass('nav-container-absolute')
    } else {
      menu.removeClass('nav-container-absolute')
      menu.addClass('nav-container-fixed')
    }
  })
}

$(() => moveScroller())
